import axios from 'axios';
import { apiInterface, WindowWithDataLayer } from '../@types/api/api';
import { UNIVERSAL_ADMIN } from '../tools/helpers/constants';

declare const window: WindowWithDataLayer;
const api: apiInterface = {
  async sendForm(data) {
    const response = await axios.post<'Success'>(`${UNIVERSAL_ADMIN}/forms`, data);
    return response.data;
  },
  async logResponseGTM({ event, eventCategory, eventAction, eventLabel }) {
    window.dataLayer.push({
      event: event,
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
    });
    return Promise.resolve();
  },
  async logDataToServer(data) {
    const response = await axios.post<{ status: string; msg: string }>(`${UNIVERSAL_ADMIN}/other_information`, data);
    return response.data;
  },
};

export { api };
